// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"c3355946","341":"ccc85cbb","382":"f786ec59","488":"a4e1ee6e","866":"b96c8209"}[chunkId] + ".chunk.js";
};